import { apiClient } from './ApiClient';

export interface TransactionFilter {
  id: number;
  name: string;
  description_pattern: string;
  amount_condition: 'equals' | 'greater_than' | 'less_than';
  amount_value: number;
  transaction_type: 'INCOME' | 'EXPENSE';
  splits: Array<{ assetId: string; percentage: number }>;
  created_at: string;
  updated_at: string;
}

export interface CreateFilterRequest {
  name: string;
  description_pattern: string;
  amount_condition: 'equals' | 'greater_than' | 'less_than';
  amount_value: number;
  transaction_type: 'INCOME' | 'EXPENSE';
  splits: Array<{ assetId: string; percentage: number }>;
}

class TransactionFilterService {
  async getFilters(): Promise<TransactionFilter[]> {
    const response = await apiClient.get('/transaction-filters');
    return response.data;
  }

  async createFilter(data: CreateFilterRequest): Promise<TransactionFilter> {
    const response = await apiClient.post('/transaction-filters', data);
    return response.data;
  }

  async updateFilter(
    filterId: number,
    data: CreateFilterRequest,
  ): Promise<TransactionFilter> {
    const response = await apiClient.put(
      `/transaction-filters/${filterId}`,
      data,
    );
    return response.data;
  }

  async deleteFilter(filterId: number): Promise<void> {
    await apiClient.delete(`/transaction-filters/${filterId}`);
  }
}

export default new TransactionFilterService();
